import { render, staticRenderFns } from "./ProjectRecord.vue?vue&type=template&id=35fbb972&scoped=true"
import script from "./ProjectRecord.vue?vue&type=script&lang=js"
export * from "./ProjectRecord.vue?vue&type=script&lang=js"
import style0 from "../../css/newProjectDetail.css?vue&type=style&index=0&id=35fbb972&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35fbb972",
  null
  
)

export default component.exports